module.exports = __webpack_public_path__ + "img/bootcamp-hero.5da6eace.jpg";